import Modal from './Modal.vue'
import MultipleAddButtons from './MultipleAddButtons.vue'

export { Modal, MultipleAddButtons }
export default Modal
